export enum BackgroundSize {
  CONTAIN = 'contain',
  COVER = 'cover'
}

export enum BackgroundRepeat {
  REPEAT = 'repeat',
  NO_REPEAT = 'no-repeat',
  REPEAT_X = 'repeat-x',
  REPEAT_Y = 'repeat-y'
}
